import React from 'react';
import { Line, SchematicShell } from './SchematicPrimitives';

/**
 * Shower niche — recessed wall cavity (typically tile-lined). Render
 * as an outer rectangle (the cavity opening) plus a short diagonal
 * tick at each corner pointing inward, a standard architectural
 * "recess" indicator that distinguishes the schematic from a generic
 * picture window.
 *
 * Side views: the niche is recessed INTO the wall, so from the side
 * it reads as a thin (~3.5") depth×height rectangle. No additional
 * detail. Symmetric left ↔ right.
 *
 * No variant fields — niches are user-placed with only dimensions.
 */

const TICK_RATIO = 0.12;
const MAX_TICK_M = 0.05;

export function ShowerNicheSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    );
  }
  const tick = Math.min(width, height) * TICK_RATIO;
  const t = Math.min(tick, MAX_TICK_M);
  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Diagonal corner ticks angled inward toward the niche center. */}
      <Line
        x1={0}
        y1={0}
        x2={t}
        y2={t}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={width}
        y1={0}
        x2={width - t}
        y2={t}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={0}
        y1={height}
        x2={t}
        y2={height - t}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      <Line
        x1={width}
        y1={height}
        x2={width - t}
        y2={height - t}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}
ShowerNicheSchematic.supportsSideViews = true;
